export const I18nService = Symbol('I18nService');

export interface I18nService {
    readonly locale: 'cn' | 'en' | 'jp' | 'tw';
    t(key: string, ...args: any[]): string;
    te(key: string, ...args: any[]): string;
}
